const content = [
  [
    // <h4>"Fresher's Party'25 coming soon"</h4>
    // "With winter around the corner, we are back with our winter projects for students interested in enhancing their skills and gaining practical experience",
    // "Winter Projects 2023",
    // "November 30, 2023",
    // "https://www.instagram.com/p/C0PDuu3IS6s/?utm_source=ig_web_copy_link&igshid=MzRlODBiNWFlZA==",
  ],
  [
    // "A interactive session designed to introduce the incredible opportunities presented by the MITACS Globalink Research Internship Programme.",
    // "Intro to MITACS Globalink",
    // "August 21, 2023",
    // "https://drive.google.com/drive/folders/1FnbBGsngKu1MHouj9sFlZyH1D2mQqCPg",
  ],
];

export { content };
